import { writable } from "svelte/store";
import type { CobaltDownloadButtonState,MediaDialogType } from "$lib/types/omnibox";

export const link = writable("");
export const downloadButtonState = writable<CobaltDownloadButtonState>("idle");
export const mediaDialog = writable<MediaDialogType>({
  isOpen: false,
  thumb: "",
  url: "",
  proxyFile: "",
  type: "photo"
});
